var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-arrow-wrapper __pointer" }, [
    _c("div", {
      staticClass: "arrow-icon",
      on: {
        click: function($event) {
          return _vm._setOrderRule(true)
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "arrow-icon",
      on: {
        click: function($event) {
          return _vm._setOrderRule(false)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }